module.exports = "import React from 'react';\nimport Spinner from '~/components/spinner';\n\nclass Example extends React.Component {\n\tstatic displayName = 'SpinnerExample';\n\n\trender() {\n\t\treturn (\n\t\t\t<div style={{ position: 'relative', height: '5rem' }}>\n\t\t\t\t<Spinner\n\t\t\t\t\tsize=\"small\"\n\t\t\t\t\tvariant=\"base\"\n\t\t\t\t\tassistiveText={{ label: 'Main Frame Loading...' }}\n\t\t\t\t/>\n\t\t\t</div>\n\t\t);\n\t}\n}\n\nexport default Example;\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./~/@salesforce/design-system-react/components/spinner/__examples__/default.jsx
// module id = 926
// module chunks = 0